import Action from "../actions";

export function jobManagementReducer(state = {
    viewList: {
        userList: [],
        total: 0
    },
    addNew: {
        isValid: false,
        isChecked: true
    },
    jobDetail:{}

}, action) {
    if (action.type === Action.SET_JOB_MANAGEMENT) {
        return action.data
    }
    return state;
}
